import React from 'react';
import ServicePage from '../components/ServicePage';
import img from '../assets/service8_1.jpeg';

const overview = [
  'Conference Room & AV Solutions including professional audio/video systems.',
  'Large Format Display Solutions covering digital signage, video walls, and projectors.',
  'Surveillance & Security Systems including CCTV and access control solutions.',
  'Public Addressing Systems for enterprise and public environments.'
];

const features = [
  { title: 'Video Conferencing',       text: 'High-quality video conferencing systems for seamless meetings' },
  { title: 'Interactive Displays',     text: 'Smart boards and interactive displays for collaborative work' },
  { title: 'Audio Systems',            text: 'Professional audio systems and microphones for clear communication' },
  { title: 'Meeting Room Automation',  text: 'Automated meeting room controls and scheduling systems' }
];

function HybridWorkspaceService() {
  return (
    <ServicePage
      title="Hybrid Workspace & AV Solutions"
      subtitle="Intelligent collaboration for in-office and remote teams"
      img={img}
      imgAlt="Hybrid Workspace & AV Solutions"
      overview={overview}
      features={features}
      backAnchor="hybrid-workspace"
    />
  );
}

export default HybridWorkspaceService;
